// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/fr-accordion/accordion.css
// module id = 11
// module chunks = 0